import { axiosReq } from "@/lib/axios";
import { DiscardedPostType } from "../../types";
import { useQuery } from "@tanstack/react-query";

export const useGetDiscardedPosts = (start_date: string = "2025-02-20", end_date: string = "2025-02-27") => {
  const request = async (): Promise<
    {
      message: string,
      data: DiscardedPostType[],
    }> => {
    const response = await axiosReq.post('/api/approval/get-discarded-posts/',
      {
        start_date: start_date,
        end_date: end_date
      });
    return response.data;
  }

  const { data: discardedPosts, isLoading } = useQuery({
    queryKey: ["discarded-socials", start_date, end_date],
    queryFn: request
  });

  return { discardedPosts, isLoading }
}
